export { CHAT_SERVICE } from './chat.service-url';
export { SEARCH_SERVICE } from './search.service-url';
export { SUMMARIZATION_SERVICE } from './summarization.service-url';
export { ADMIN_SERVICE } from './admin.service-url';
export { CONVERSATION_SERVICE } from './conversation.service-url';
export { DOCUMENTS_SERVICE } from './documents.service-url';
export { NOTIFICATION_SERVICE } from './notification.service-url';
export { AUTH_SERVICE } from './auth.service-url';
export { AVATAR_SERVICE } from './avatar.service-url';
export { ROLEPLAY_SERVICE } from './roleplay.service-url';
export { KNOWLEDGE_CHECK_SERVICE } from './knowledge-check.service-url';
export { SECRETS_SERVICE } from './secrets.service-url';
export { EVALUATION_SERVICE } from './evaluation.service-url';
